// Aggiorna variabili CSS per header app, barra filtri, chrome intermedio e pannelli.
const DEFAULT_HEADER_HEIGHT = 65;
const DEFAULT_FILTER_BAR_HEIGHT = 75;

function measureBlockHeight(el) {
  if (!el) return 0;
  return Math.max(el.offsetHeight, el.scrollHeight);
}

function isFixedChrome(el) {
  return window.getComputedStyle(el).position === 'fixed';
}

export function updateLayoutOffsets() {
  const measure = () => {
    const headerEl = document.querySelector('.r-app-header-root > div:first-child');
    const listHeaderEl = document.querySelector('.list-view-header');

    const headerHeight = headerEl
      ? measureBlockHeight(headerEl)
      : DEFAULT_HEADER_HEIGHT;

    let listViewHeaderTop = headerHeight;
    document.querySelectorAll('[data-layout-chrome="before-filter"]').forEach((el) => {
      if (isFixedChrome(el)) {
        listViewHeaderTop += measureBlockHeight(el);
      }
    });

    const listHeaderHeight = listHeaderEl
      ? measureBlockHeight(listHeaderEl)
      : DEFAULT_FILTER_BAR_HEIGHT;

    let toolbarTop = listViewHeaderTop + listHeaderHeight;
    let contentTop = toolbarTop;

    document.querySelectorAll('.r-flow-on-phone, .r-layout-offset-chrome').forEach((el) => {
      if (isFixedChrome(el)) {
        contentTop += measureBlockHeight(el);
      }
    });

    document.documentElement.style.setProperty('--app-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--list-view-header-top', `${listViewHeaderTop}px`);
    document.documentElement.style.setProperty('--list-view-header-height', `${listHeaderHeight}px`);
    document.documentElement.style.setProperty('--list-view-toolbar-top', `${toolbarTop}px`);
    document.documentElement.style.setProperty('--list-view-content-top', `${contentTop}px`);
  };

  requestAnimationFrame(() => requestAnimationFrame(measure));
}

export function observeLayoutTargets(onUpdate) {
  if (typeof ResizeObserver === 'undefined') {
    return () => {};
  }

  const observers = [];
  const observe = (el) => {
    const ro = new ResizeObserver(onUpdate);
    ro.observe(el);
    observers.push(ro);
  };

  const headerEl = document.querySelector('.r-app-header-root > div:first-child');
  if (headerEl) observe(headerEl);

  document.querySelectorAll('[data-layout-chrome="before-filter"]').forEach(observe);

  const listHeaderEl = document.querySelector('.list-view-header');
  if (listHeaderEl) observe(listHeaderEl);

  document.querySelectorAll('.r-flow-on-phone, .r-layout-offset-chrome').forEach(observe);

  return () => {
    observers.forEach((ro) => ro.disconnect());
  };
}
